import React from "react";
import { font } from "./constants";

/** Primary CTA after persona/audiences are ready — triggers query generation. */
function AudienceContinueButton({
  onClick,
  loading = false,
  disabled = false,
  label = "Continue",
}) {
  const isDisabled = disabled || loading;
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isDisabled}
      style={{
        width: "100%",
        padding: "14px 0",
        borderRadius: 10,
        border: "none",
        background: "linear-gradient(135deg, #22c55e, #16a34a)",
        color: "#fff",
        fontSize: 15,
        fontWeight: 600,
        cursor: isDisabled ? "not-allowed" : "pointer",
        fontFamily: font,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        boxShadow: "0 4px 20px rgba(34,197,94,0.2)",
        opacity: isDisabled ? 0.7 : 1,
        marginTop: 14,
      }}
    >
      {loading ? "Continuing…" : `▶ ${label}`}
    </button>
  );
}

export default AudienceContinueButton;
